<template>
    <router-view/>
</template>

<script>
export default {
    name: 'app'
}
</script>

<style>
@import 'oasis/dist/static/components.css';
    html,body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #4F4F4F;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue